import FizConfig from "../FizConfig.ts";
import * as Storage from "../lib/Storage.ts";

Storage.sessionSet("lang",document.getElementsByTagName('html').item(0)!.getAttribute('lang')!);

//launch autologin process if it might works
if(['/index.html','/'].indexOf(window.location.pathname)>-1){
  var
    rememberIdentifier = Storage.localGet("rememberIdentifier"),
    rememberToken = Storage.localGet("rememberToken");

  if (window.location.search.indexOf("noautologin")===-1 && window.location.search.indexOf("apidown")===-1 && rememberIdentifier && rememberToken && (rememberIdentifier+rememberToken).length>0){
    window.location.href="home.php";
  }
}

document.querySelectorAll('a.itunelink').forEach((a: Element)=>{
  const link = a as HTMLAnchorElement;
  if(!link.classList.contains('disabled')){
    link.setAttribute('href',FizConfig.IPHONE_DOWNLOAD_URL);
  }
})
document.querySelectorAll('a.gplaylink').forEach((a: Element)=>{
  const link = a as HTMLAnchorElement;
  if(!link.classList.contains('disabled')){
    link.setAttribute('href',FizConfig.ANDROID_DOWNLOAD_URL);
  }
})
document.querySelectorAll('a.downloadlink').forEach((a: Element)=>{
  const link = a as HTMLAnchorElement;
  if(!link.classList.contains('disabled')){
    link.setAttribute('href',FizConfig.API_BASE_URL+'dl');
  }
})
document.querySelector('.header button')!.addEventListener('click',function(this: HTMLElement, evt: MouseEvent){
  this.parentElement!.classList.toggle('fw-open');
  evt.stopPropagation();
  document.addEventListener('scroll',()=>{
    this.parentElement!.classList.remove('fw-open')
  },{once:true})
  document.addEventListener('click',()=>{
    this.parentElement!.classList.remove('fw-open')
  },{once:true})

});


if(Storage.sessionGet('isLoggued')==='true'){
  document.querySelectorAll('a').forEach((a: HTMLAnchorElement)=>{
    if(a.getAttribute('href') && a.getAttribute('href')!.indexOf('index.html')===0){
      a.setAttribute('href','home.php');
    }
  });
}
